import React, { useEffect, useState } from 'react';
import { CalendarDays } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Calendar } from './ui/calendar';

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const parse = (s) => new Date(`${s}T00:00:00`);

export const MonthPicker = ({ authFetch, value, onPick }) => {
  const [open, setOpen] = useState(false);
  const [month, setMonth] = useState(() => parse(value));
  const [counts, setCounts] = useState({});
  const key = `${month.getFullYear()}-${String(month.getMonth() + 1).padStart(2, '0')}`;

  useEffect(() => { if (open) setMonth(parse(value)); }, [open, value]);
  useEffect(() => {
    if (!open) return;
    let live = true;
    authFetch('get', `/admin/calendar/month-counts?month=${key}`).then(({ data }) => { if (live) setCounts(data.counts); }).catch(() => {});
    return () => { live = false; };
  }, [authFetch, key, open]);

  const booked = Object.keys(counts).map(parse);
  const DayContent = ({ date }) => {
    const n = counts[ymd(date)];
    return (
      <span className="relative flex flex-col items-center leading-none" data-testid={`month-day-${ymd(date)}`}>
        {date.getDate()}
        {n ? <span className="absolute -bottom-2.5 text-[9px] font-black text-[color:var(--mv-orange)]">{n}</span> : null}
      </span>
    );
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="inline-flex items-center gap-1.5 h-9 px-3 rounded-md border border-slate-200 bg-white text-xs font-bold text-[color:var(--mv-navy)] hover:border-[color:var(--mv-orange)]" data-testid="cal-month-picker-btn">
          <CalendarDays className="w-4 h-4 text-[color:var(--mv-orange)]" /> Month
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="end" data-testid="cal-month-picker">
        <Calendar
          mode="single"
          selected={parse(value)}
          month={month}
          onMonthChange={setMonth}
          onSelect={(d) => { if (d) { onPick(ymd(d)); setOpen(false); } }}
          weekStartsOn={1}
          modifiers={{ booked }}
          modifiersClassNames={{ booked: 'font-black text-[color:var(--mv-navy)] bg-orange-50' }}
          components={{ DayContent }}
          classNames={{ cell: 'h-10 w-10 text-center text-sm p-0 relative', day: 'h-10 w-10 p-0 font-normal rounded-md hover:bg-slate-100 aria-selected:bg-[color:var(--mv-navy)] aria-selected:text-white' }}
        />
        <div className="px-3 pb-3 text-[11px] text-slate-500">Orange number = bookings that day. Tap a day to open it.</div>
      </PopoverContent>
    </Popover>
  );
};
